import React from 'react';
import ListActions from './ListActions'
import {
	List,
	Responsive,
	SimpleList,
	Datagrid,
	TextField,
	NumberField,
	DateField,
	RichTextField,
	FunctionField,
} from 'admin-on-rest'
import { NoDealershipYearMonthFilters } from './Filters'

const rowStyle = (record, index) => ({
	fontWeight: record.is_total ? 'bold' : 'normal',
	backgroundColor: record.is_total ? '#fafafa' : '',
});

/**
 * Shows the
 */
export const CollectionStatus = (props) => (
    <List {...props}
		title="Collection Status"
		filters={<NoDealershipYearMonthFilters/>}
		actions={<ListActions refreshInterval="900000" />}
		>
		<Responsive
            // small={
            //     <SimpleList
            //         primaryText={record => record.cs_num}
            //     />
            // }
            large={
				<Datagrid rowStyle={rowStyle}>
					<TextField source="dealership" label="Dealership" />
					<TextField source="total_releases" label="Total Releases" />
					<TextField source="transmitted" label="Transmitted" />
					<TextField source="review" label="Review" />
					<TextField source="booking" label="Booked" />
					<TextField source="for_collection" label="For Collection" />
					<TextField source="proceeds_collected" label="Proceeds Collected" />
					<TextField source="di_collected" label="DI Collected" />
					<TextField source="doc_def" label="Doc Def" />
		        </Datagrid>
            }
        />
    </List>
)



// WEBPACK FOOTER //
// ./src/reports/CollectionStatus.js